import { TouchableOpacity, Text, StyleSheet } from "react-native";
import { useState } from "react";
import { useDevice } from "../../_layout";
import Colors from "../../../Resources/Color";
import CustomActivityIndicator from "../../Components/CustomActivityIndicator";

/**
 * ContinueButton Component
 * A reusable button for onboarding navigation
 */
const ContinueButton = ({
  onPress,
  disabled = false,
  text = "Continue",
  isLoading = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const { isMobile } = useDevice();

  // Calculate background color (we animate opacity for disabled; hover changes color)
  const enabledBg = Colors.bubbleColor;
  const hoveredBg = "#2E5E6E";

  const backgroundColor = isHovered && !disabled ? hoveredBg : enabledBg;

  return (
    <TouchableOpacity
      style={[
        styles.button,
        { backgroundColor },
        disabled && styles.buttonDisabled,
        // Ensure web hover/opacity transitions run by including a transition string inline
        {
          transition:
            "background-color 200ms ease-in-out, opacity 200ms ease-in-out",
        },
      ]}
      onPress={onPress}
      disabled={disabled || isLoading}
      onMouseEnter={() => !isMobile && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isLoading ? (
        <CustomActivityIndicator large={false} white={true} />
      ) : (
        <Text
          style={[styles.buttonText, disabled && styles.buttonTextDisabled]}
        >
          {text}
        </Text>
      )}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: "100%",
    maxWidth: 360,
    height: 46,
    borderRadius: 14,
    backgroundColor: Colors.bubbleColor,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "center",
    transitionProperty: "background-color, opacity",
    transitionDuration: "800ms",
    transitionTimingFunction: "ease-in-out",
    cursor: "pointer",
  },
  buttonDisabled: {
    opacity: 0.4,
  },
  buttonHovered: {
    backgroundColor: "#2E5E6E",
  },
  buttonText: {
    fontSize: 14,
    fontWeight: "500",
    color: Colors.whiteColor,
  },
  buttonTextDisabled: {
    color: Colors.whiteColor,
  },
});

export default ContinueButton;
